module.exports = __webpack_public_path__ + "img/nav-bottom-deposit-active.8a0b809a.png";